<template>
  <el-dialog :visible.sync="dialogVisible" width="65%">
    <div slot="title" class="title">{{ title }}</div>

    <div class="tab-box">
      <el-table
        :data="tableData"
        style="width: 100%"
        :header-cell-style="{ background: '#F6F6F6', color: '#606266' }"
      >
       <!-- <el-table-column
          v-for="(v, k) in tabData"
          :key="k"
          :prop="v.prop"
          :label="v.name"
        >
        </el-table-column> -->
        <el-table-column prop="order_no" label="订单编号"> </el-table-column>
        <el-table-column label="客户名称"> 
			<template v-if="scope.row.report" slot-scope="scope">{{scope.row.report.name}}</template>
		</el-table-column>
        <el-table-column prop="price" label="订单金额"> </el-table-column>
        <el-table-column prop="start_time" label="订单开始时间"> </el-table-column>
        <el-table-column prop="end_time" label="订单结束时间"> </el-table-column>
		<el-table-column prop="occupy_start_time" label="占用开始时间"> </el-table-column>
		<el-table-column prop="occupy_end_time" label="占用结束时间"> </el-table-column>
        <!-- <el-table-column prop="address" label="投放形式"> </el-table-column> -->
      </el-table>
    </div>
    <span slot="footer" class="dialog-footer">
      <!-- 分页 -->
      <div class="page-box">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 15, 20, 30, 50, 100]"
          :page-size="10"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          >&emsp;
        </el-pagination>
      </div>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default() {
        return "点位列表";
      },
    },
    tabData: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
		total:0,
      dialogVisible: false,
      currentPage: 1, //当前页
      tableData: [
        {
          date: "1",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄",
        },
      ],
	  pageObj2: {
	  	limit: 10,
	  	page: 1,
	  },
    };
  },
  methods: {
	  getList(){
		  this.$api2.indexOrder(this.pageObj2).then((res)=>{
		  	if(res.code == 1){
		  		this.tableData = res.data
		  		this.total = res.count
		  	}else{
		  		this.$message.error(res.msg)
		  	}
		  })
	  },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
	  this.pageObj2.limit = val;
	  this.getList()
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
	  this.pageObj2.page = val;
	  this.getList()
    },
  },
};
</script>

<style lang="scss" scoped>
.tab-box /deep/ {
  .el-table {
    border: 1px solid #f1f3f4;
  }
  
}
/deep/ .el-dialog__body {
    padding-bottom: 0 !important;
  }
.small-btn:hover {
  opacity: 0.8 !important;
}
.small-btn:active {
  opacity: 0.9 !important;
}
</style>